import { render } from "./FilePreviewModal.vue?vue&type=template&id=1b0817aa"
import script from "./FilePreviewModal.vue?vue&type=script&lang=js"
export * from "./FilePreviewModal.vue?vue&type=script&lang=js"

import "./FilePreviewModal.vue?vue&type=style&index=0&id=1b0817aa&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__